import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/styles.css';
import '../styles/formularios.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import logoInstituto from '../components/images/logo.png';
import logoSEP from '../components/images/SEP_Logo_2019.svg.png.jpg';

// Librerías de exportación
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const ConsultarHorariosGrupo = () => {
  const [grupoSeleccionado, setGrupoSeleccionado] = useState('');
  const [mostrarResultado, setMostrarResultado] = useState(false);
  const [horarios, setHorarios] = useState([]);
  const [nombreGrupo, setNombreGrupo] = useState('');

  const consultarHorario = () => {
    if (grupoSeleccionado !== '') {
      const grupoTexto = document.querySelector('#grupo option:checked').text;
      setNombreGrupo(grupoTexto);
      setHorarios([
        { materia: "Matemáticas", dia: "Lunes", horaInicio: "08:00", horaFin: "10:00", aula: "A01" },
        { materia: "Historia", dia: "Miércoles", horaInicio: "10:00", horaFin: "12:00", aula: "B02" },
        { materia: "Física", dia: "Viernes", horaInicio: "08:00", horaFin: "10:00", aula: "B01" }
      ]);
      setMostrarResultado(true);
    } else {
      alert("Por favor, selecciona un grupo.");
    }
  };

  const exportarExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(document.getElementById('tablaHorariosAlumno'));
    XLSX.utils.book_append_sheet(wb, ws, "Horarios");
    XLSX.writeFile(wb, "horarios.xlsx");
  };

  const exportarPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({ html: '#tablaHorariosAlumno' });
    doc.save('horarios.pdf');
  };

  return (
    <div className="container py-4 px-4">
      {/* Encabezado */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src={logoInstituto} alt="Logo Instituto" className="logo" />
        <div className="flex-grow-1 text-center">
          <h4 className="mb-0">Instituto Silviano Carrillo</h4>
          <small className="text-muted fs-5">Consulta de Horarios por Grupo</small>
        </div>
        <img src={logoSEP} alt="Logo SEP" className="logo" />
      </div>

      {/* Formulario de consulta */}
      <div className="p-4 bg-light rounded shadow-sm">
        <form className="row g-3">
          <div className="col-md-12">
            <label htmlFor="grupo" className="form-label">Selecciona tu grupo</label>
            <select
              className="form-select"
              id="grupo"
              value={grupoSeleccionado}
              onChange={(e) => setGrupoSeleccionado(e.target.value)}
            >
              <option value="">Selecciona un grupo...</option>
              <option value="1">Primero</option>
              <option value="2">Segundo</option>
              <option value="3">Tercero</option>
            </select>
          </div>

          <div className="col-md-12">
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={consultarHorario}
            >
              Consultar Horario
            </button>
          </div>
        </form>
      </div>

      {/* Resultado de la consulta */}
      {mostrarResultado && (
        <div id="resultadoConsultaAlumno" className="mt-4">
          <h5 className="text-center">Horario del Grupo <span>{nombreGrupo}</span></h5>
          <table id="tablaHorariosAlumno" className="table table-bordered">
            <thead>
              <tr>
                <th>Materia</th>
                <th>Día</th>
                <th>Hora de Inicio</th>
                <th>Hora de Finalización</th>
                <th>Aula</th>
              </tr>
            </thead>
            <tbody>
              {horarios.map((h, index) => (
                <tr key={index}>
                  <td>{h.materia}</td>
                  <td>{h.dia}</td>
                  <td>{h.horaInicio}</td>
                  <td>{h.horaFin}</td>
                  <td>{h.aula}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Botones de exportación */}
          <div className="mt-3 d-flex justify-content-end gap-2">
            <button className="btn btn-outline-success" onClick={exportarExcel}>Exportar a Excel</button>
            <button className="btn btn-outline-danger" onClick={exportarPDF}>Exportar a PDF</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConsultarHorariosGrupo;
